/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_Art_NoteInputs */

const en_services_svc_save_art_note = /** @type {(inputs: Services_Svc_Save_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative answer. Your documents define the detail.`)
};

const lv_services_svc_save_art_note = /** @type {(inputs: Services_Svc_Save_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbilde ilustrācijai. Detaļas nosaka Jūsu dokumenti.`)
};

/**
* | output |
* | --- |
* | "Illustrative answer. Your documents define the detail." |
*
* @param {Services_Svc_Save_Art_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_art_note = /** @type {((inputs?: Services_Svc_Save_Art_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_Art_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_art_note(inputs)
	return en_services_svc_save_art_note(inputs)
});